import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface LinhVucDieuTra {
  name: string;
  api_token: string;
}

export interface LinhVucDieuTraListInfor {
  errors: unknown;
  linhVucDieutra: LinhVucDieuTra;
  isAuthenticated: boolean;
}

@Module
export default class LinhVucDieuTraModule
  extends VuexModule
  implements LinhVucDieuTraListInfor
{
  errors = {};
  linhVucDieutra = {} as LinhVucDieuTra;
  isAuthenticated = !!JwtService.getToken();

  get LinhVucDieuTras() {
    return this.gisLinhVucDieuTraListData;
  }

  get LinhVucDieuTraDetail() {
    return this.gisLinhVucDieuTraDetailData;
  }

  @Mutation
  [Mutations.GIS_LINH_VUC_DIEU_TRA_LIST_DATA](LinhVucDieuTras) {
    this.gisLinhVucDieuTraListData = LinhVucDieuTras;
  }

  @Mutation
  [Mutations.GIS_LINH_VUC_DIEU_TRA_DETAIL_DATA](Document) {
    this.gisLinhVucDieuTraDetailData = Document;
  }

  @Action
  [Actions.GIS_LINH_VUC_DIEU_TRA_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("gis/dmlinhvucdieutra/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.GIS_LINH_VUC_DIEU_TRA_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.GIS_LINH_VUC_DIEU_TRA_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("gis/dmlinhvucdieutra", payload)
        .then((data) => {
          this.context.commit(Mutations.GIS_LINH_VUC_DIEU_TRA_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.GIS_LINH_VUC_DIEU_TRA_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/gis/dmlinhvucdieutra",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.GIS_LINH_VUC_DIEU_TRA_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.GIS_LINH_VUC_DIEU_TRA_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/gis/dmlinhvucdieutra",
        "upsert",
        id,
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.GIS_LINH_VUC_DIEU_TRA_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.GIS_LINH_VUC_DIEU_TRA_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/gis/dmlinhvucdieutra",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.GIS_LINH_VUC_DIEU_TRA_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
